<template>
	<drawer
			title="Choose company name"
			@updateClose="onClose"
			@updateSave="onSave"
	>
		<div class="editTransactions">

			<div class="editTransactions__block">
				<div class="subTitle">
					Customer
				</div>

				<field
						width="100%"
						margin="0"
						label="Customer"
						placeholder="Select customer"
						:items="customers"
						:autocompleteValue="selectedCustomer"
						item-text="value"
						item-value="customer_id"
						isAutocomplete
						isClearable
						isAttach
						@updateAutocomplete="onCustomerChange"
						@updateClearAutocomplete="onCustomerClear"
				/>
			</div>

			<div class="editTransactions__block">
				<div class="subTitle">
					Transaction information
				</div>

				<div class="transactionInfo">

					<div class="transactionInfo__item">
						<div class="transactionInfo__label">
							ID
						</div>

						<div class="transactionInfo__value">
							{{ getValue(item.id) }}
						</div>
					</div>

					<div class="transactionInfo__item">
						<div class="transactionInfo__label">
							Transaction ID
						</div>

						<div class="transactionInfo__value">
							{{ getValue(item.transaction_id) }}
						</div>
					</div>

					<div class="transactionInfo__item">
						<div class="transactionInfo__label">
							Type
						</div>

						<div class="transactionInfo__value">
							{{ getValue(item.name) }}
						</div>
					</div>

					<div class="transactionInfo__item">
						<div class="transactionInfo__label">
							Amount
						</div>

						<div class="transactionInfo__value">
							{{ getAmount(item.amount) }}
						</div>
					</div>

					<div class="transactionInfo__item">
						<div class="transactionInfo__label">
							Date
						</div>

						<div class="transactionInfo__value">
							{{ getValue(item.date) }}
						</div>
					</div>

					<div class="transactionInfo__item">
						<div class="transactionInfo__label">
							Customer ID
						</div>

						<div class="transactionInfo__value">
							{{ getValue(item.customer_id) }}
						</div>
					</div>

					<div class="transactionInfo__item transactionInfo__item--full">
						<div class="transactionInfo__label">
							Original description
						</div>

						<div class="transactionInfo__value transactionInfo__value--description">
							{{ getValue(item.original_description) }}
						</div>
					</div>

<!--					<div class="transactionInfo__item">-->
<!--						<div class="transactionInfo__label">-->
<!--							Created at-->
<!--						</div>-->

<!--						<div class="transactionInfo__value">-->
<!--							{{ getValue(item.created_at) }}-->
<!--						</div>-->
<!--					</div>-->

<!--					<div class="transactionInfo__item">-->
<!--						<div class="transactionInfo__label">-->
<!--							Updated at-->
<!--						</div>-->

<!--						<div class="transactionInfo__value">-->
<!--							{{ getValue(item.updated_at) }}-->
<!--						</div>-->
<!--					</div>-->

				</div>
			</div>

		</div>
	</drawer>
</template>

<script>
import Drawer from "@/shared/Drawer/Drawer.vue";
import Field from "@/shared/Field/Field.vue";

export default {
	name: "EditTransactions",

	components: {
		Drawer,
		Field,
	},

	props: {
		customers: {
			type: Array,
			default: () => [],
		},

		item: {
			type: Object,
			default: () => ({}),
		},
	},

	data() {
		return {
			selectedCustomer: null,
		};
	},

	watch: {
		item: {
			immediate: true,
			deep: true,
			handler() {
				this.setCustomer();
			},
		},

		customers: {
			immediate: true,
			deep: true,
			handler() {
				this.setCustomer();
			},
		},
	},

	methods: {
		/**
		 * Set current customer from transaction.
		 *
		 * @returns {void}
		 */
		setCustomer() {
			if (!this.item || !this.item.customer_id) {
				this.selectedCustomer = null;

				return;
			}

			this.selectedCustomer = this.customers.find(customer => {
				return Number(customer.customer_id) === Number(this.item.customer_id);
			}) || null;
		},

		/**
		 * Change selected customer.
		 *
		 * @param {Object} payload Autocomplete payload.
		 * @returns {void}
		 */
		onCustomerChange({ value }) {
			this.selectedCustomer = value;
		},

		/**
		 * Clear selected customer.
		 *
		 * @returns {void}
		 */
		onCustomerClear() {
			this.selectedCustomer = null;
		},

		/**
		 * Get display value.
		 *
		 * @param {*} value Value.
		 * @returns {String|Number} Display value.
		 */
		getValue(value) {
			if (value === null || value === undefined || value === '') {
				return '—';
			}

			return value;
		},

		/**
		 * Get formatted transaction amount.
		 *
		 * @param {String|Number} value Amount.
		 * @returns {String} Formatted amount.
		 */
		getAmount(value) {
			if (value === null || value === undefined || value === '') {
				return '—';
			}

			return `$${ Number(value).toFixed(2) }`;
		},

		/**
		 * Close drawer.
		 *
		 * @returns {void}
		 */
		onClose() {
			this.$emit('updateClose', false);
		},

		/**
		 * Save selected customer.
		 *
		 * @returns {void}
		 */
		onSave() {
			const values = {
				id: this.item.id,
				customer_id: this.selectedCustomer
					? this.selectedCustomer.customer_id
					: null,
			};

			this.$emit('updateSave', values);
		},
	},
};
</script>

<style scoped lang="scss">
.editTransactions {
	padding-bottom: 20px;

	&__block {
		margin-bottom: 30px;
	}
}

.subTitle {
	margin-bottom: 20px;

	color: var(--base-green);
	font-size: 16px;
	font-weight: 500;
	line-height: 20px;
	letter-spacing: 0.25px;
}

.transactionInfo {
	display: grid;
	grid-template-columns: repeat(2, minmax(0, 1fr));

	border: 1px solid rgba(255, 255, 255, 0.08);
	border-radius: 6px;

	overflow: hidden;

	&__item {
		min-width: 0;
		padding: 12px 14px;

		border-right: 1px solid rgba(255, 255, 255, 0.08);
		border-bottom: 1px solid rgba(255, 255, 255, 0.08);

		&:nth-child(2n) {
			border-right: none;
		}

		&--full {
			grid-column: 1 / -1;

			border-right: none;
		}
	}

	&__label {
		margin-bottom: 5px;

		color: var(--card-color-sub-title);
		font-size: 11px;
		font-weight: 500;
		line-height: 14px;
		text-transform: uppercase;
	}

	&__value {
		color: var(--card-color);
		font-size: 13px;
		line-height: 18px;

		word-break: break-word;

		&--description {
			line-height: 20px;
		}
	}

	@media screen and (max-width: 768px) {
		grid-template-columns: 1fr;

		&__item {
			border-right: none;

			&--full {
				grid-column: auto;
			}
		}
	}
}
</style>
